import {
  bereavementURL,
  billPageURL,
  businessCustomerURL,
  cancelOverPhoneURL,
  cancelServiceURL,
} from "../../constants/flowId";
import type { ITGMetadata } from "@ceeferenderer/fe-renderer-sdk/model/itgMetadata.model";
import { buildTrackingTag } from "../../utils/buildTrackingTag";
import { render } from "../../utils/render";

// eslint-disable-next-line sonarjs/cognitive-complexity
export const handleRender = (htmlString: string, metaData: ITGMetadata): void => {
  const html: Node = document.createRange().createContextualFragment(htmlString);
  html.appendChild(buildTrackingTag(metaData));
  render(
    html,
    Object.values(metaData)
      .map((value) => value.replace(/\s/g, "-"))
      .join(" ")
  );
  const subscriberNexusReasonLevel1: any = document.querySelectorAll("[data-rsmonitor='answerIdSelected']")[0];
  const subscriberNexusReasonLevel2: any = document.querySelectorAll("[data-rsmonitor='newAnswerIdSelected']")[0];
  const subscriberNexusReasonLevel3: any = document.querySelectorAll("[rsmonitor='subAnswerIdSelected']")[0];

  // Existing customer - Reset Level2 and Level3 Reason selection, whenever level1 Reason changes
  if (subscriberNexusReasonLevel1) {
    subscriberNexusReasonLevel1.addEventListener("change", (event: any) => {
      const submitButton: any = document.getElementById("submitButtonValue");

      if (subscriberNexusReasonLevel2) {
        subscriberNexusReasonLevel2.value = null;
      }
      if (subscriberNexusReasonLevel3) {
        subscriberNexusReasonLevel3.value = null;
      }
      if (submitButton) {
        submitButton.value = null;
      }
      let eventAction = "";
      const level1 = "customer|level1|";
      eventAction = level1 + event?.target?.name?.replace(" arrow icon", "");
      subscriberNexusReasonLevel1.dispatchEvent(
        new CustomEvent("c-tracking-log-dom", {
          bubbles: true,
          composed: false, // "composed" is only needed for Shadow DOM support
          detail: {
            eventAction,
          },
        })
      );
    });
  }

  // //Existing customer - Reset Level3 Reason selection, whenever level2 Reason changes
  if (subscriberNexusReasonLevel2) {
    subscriberNexusReasonLevel2.addEventListener("change", (event: any) => {
      const submitButton: any = document.getElementById("submitButtonValue");
      if (subscriberNexusReasonLevel3) {
        subscriberNexusReasonLevel3.value = null;
      }
      if (submitButton) {
        submitButton.value = null;
      }
      let eventAction = "";
      const level2 = "customer|level2|";
      eventAction = level2 + event?.target?.name?.replace(" arrow icon", "");
      subscriberNexusReasonLevel2.dispatchEvent(
        new CustomEvent("c-tracking-log-dom", {
          bubbles: true,
          composed: false, // "composed" is only needed for Shadow DOM support
          detail: {
            eventAction,
          },
        })
      );
    });
  }

  const populateListenContactFieldChange = (elmId: string, listener: string) => {
    const elm = <HTMLInputElement>document.querySelectorAll(elmId)[0];
    if (elm) {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      elm.removeEventListener(listener, () => {});

      elm.addEventListener(listener, () => {
        getBookAppointmentStatus();
      });
    }
  };
  const prospoectReasonSelectElement = <HTMLSelectElement>(
    document.querySelectorAll("[rsmonitor='answerIdSelected']")[0]
  );

  const multiSelectDropdownElement = <HTMLSelectElement>document.getElementById("choose-your-services-multiselect-btn");
  if (multiSelectDropdownElement) {
    multiSelectDropdownElement.addEventListener("click", () => {
      const elm: any = document.getElementById("choose-your-services-multiselect-btn");
      if (elm) {
        let eventAction = "";
        if (sessionStorage.getItem("userSelected") === "guest") {
          const guestLevel1 = "guest|level1|";
          eventAction = guestLevel1 + elm?.textContent.replace(" arrow icon", "");
          prospoectReasonSelectElement.dispatchEvent(
            new CustomEvent("c-tracking-log-dom", {
              bubbles: true,
              composed: false, // "composed" is only needed for Shadow DOM support
              detail: {
                eventAction,
              },
            })
          );
        } else {
          const level3 = "customer|level3|";
          const level2 = "customer|level2|";
          if (subscriberNexusReasonLevel2) {
            eventAction = level3 + elm?.textContent.replace(" arrow icon", "");
          } else {
            eventAction = level2 + elm?.textContent.replace(" arrow icon", "");
          }
          subscriberNexusReasonLevel1.dispatchEvent(
            new CustomEvent("c-tracking-log-dom", {
              bubbles: true,
              composed: false, // "composed" is only needed for Shadow DOM support
              detail: {
                eventAction,
              },
            })
          );
        }
      }
    });
  }
  const getBookAppointmentStatus = () => {
    const submitButton: any = document.querySelector(".retail-av-primary-btn");
    const contactFirstName: any = document.querySelectorAll("[rsmonitor='custFirstNameVal']")[0];
    const contactLastName: any = document.querySelectorAll("[rsmonitor='custLastNameVal']")[0];
    const contactEmail: any = document.querySelectorAll("[rsmonitor='custEmailVal']")[0];
    const contactPhone: any = document.querySelectorAll("[rsmonitor='custPhoneVal']")[0];
    if (contactFirstName) {
      contactFirstName.addEventListener("keypress", (event: any) => restrictInputSpecialCharacter(event));
      contactFirstName.addEventListener("paste", (event: any) => restrictInputSpecialCharacter(event));
      contactFirstName.value = contactFirstName.value.replace(/[\r\n\\&><]+/g, " ");
      contactFirstName.value = contactFirstName.value.replace(/["]+/g, "");
    }
    if (contactLastName) {
      contactLastName.addEventListener("keypress", (event: any) => restrictInputSpecialCharacter(event));
      contactLastName.addEventListener("paste", (event: any) => restrictInputSpecialCharacter(event));
      contactLastName.value = contactLastName.value.replace(/[\r\n\\&<>]+/g, " ");
      contactLastName.value = contactLastName.value.replace(/["]+/g, "");
    }
    if (contactPhone) {
      contactPhone.setAttribute("maxlength", "14");
    }
    if (contactPhone && contactPhone.value.trim().length > 0) {
      const x = contactPhone.value.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      contactPhone.value = !x[2] ? x[1] : `(${x[1]}) ${x[2]}`;
      contactPhone.value += x[3] ? `-${x[3]}` : "";
    }
    if (
      contactFirstName &&
      contactFirstName.value.trim().length > 0 &&
      contactLastName &&
      contactLastName.value.trim().length > 0 &&
      contactEmail &&
      contactEmail.value.trim().length > 0 &&
      contactPhone &&
      contactPhone.value.trim().length > 0 &&
      submitButton
    ) {
      let emailMatch = true;
      let phoneMatch = true;
      // const emailRegex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      const emailRegex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@([a-zA-Z0-9-]+)\.[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

      emailMatch = emailRegex.test(contactEmail.value.trim());
      const phoneRegex = /^(?:\+1)?(?:\(\d{3}\)|\d{3})[ -]?\d{3}[ -]?\d{4}$/;
      phoneMatch = phoneRegex.test(contactPhone.value.trim());
      if (emailMatch && phoneMatch) {
        submitButton.classList.remove("disabledButton");
        submitButton.classList.add("enableButton");
      } else {
        submitButton.classList.remove("enableButton");
        submitButton.classList.add("disabledButton");
      }
    } else {
      submitButton.classList.remove("enableButton");
      submitButton.classList.add("disabledButton");
    }
  };
  const restrictInputSpecialCharacter = (event: any) => {
    if (
      event &&
      (event.keyCode === 13 ||
        event.keyCode === 92 ||
        event.keyCode === 220 ||
        event.keyCode === 34 ||
        event.keyCode === 60 ||
        event.keyCode === 62 ||
        event.keyCode === 38)
    ) {
      event.preventDefault();
    }
    setTimeout(() => {
      event.target.value = event.target.value.replace(/[\r\n\\&><]+/g, " ");
      event.target.value = event.target.value.replace(/["]+/g, "");
    });
  };
  if (metaData.stepName && metaData.stepName.toLowerCase() === "contact details") {
    populateListenContactFieldChange("[rsmonitor='custFirstNameVal']", "input");
    populateListenContactFieldChange("[rsmonitor='custLastNameVal']", "input");
    populateListenContactFieldChange("[rsmonitor='custEmailVal']", "input");
    populateListenContactFieldChange("[rsmonitor='custPhoneVal']", "input");
    const infoButton: any = document.querySelectorAll("#infoBtn")[0];
    const infoClose: any = document.querySelectorAll("#infoClose")[0];
    const modalPanel: any = document.querySelectorAll(".modal-hide")[0];
    if (infoButton) {
      infoButton.onclick = function () {
        if (modalPanel) {
          modalPanel.classList.toggle("modal-hide");
        }
      };
    }
    if (infoClose) {
      infoClose.onclick = function () {
        if (modalPanel) {
          modalPanel.classList.add("modal-hide");
        }
      };
    }
    getBookAppointmentStatus();
  }
  if (metaData.stepName === "Billing Services") {
    const billButton: any = document.querySelectorAll("#payBillButton")[0];
    if (billButton) {
      billButton.onclick = function () {
        window.open(billPageURL, "_blank");
      };
    }
  }
  if (metaData.stepName === "Launch Screen") {
    const isOutageBannerEnabled: any = document.querySelectorAll("[rsmonitor='isOutageBannerEnabled']")[0];
    const isMaintenanceEnabled: any = document.querySelectorAll("[rsmonitor='isMaintenanceEnabled']")[0];
    const businessCustomerButton: any = document.querySelectorAll("#businessCustomer")[0];
    const exisitngCustomerButton: any = document.querySelectorAll("#existingCustomer")[0];
    const newCustomerButton: any = document.querySelectorAll("#newCustomer")[0];

    if (
      (isOutageBannerEnabled && JSON.parse(isOutageBannerEnabled.value)) ||
      (isMaintenanceEnabled && JSON.parse(isMaintenanceEnabled.value))
    ) {
      const cls = ["disabledButton"];
      businessCustomerButton.classList.add(...cls);
      exisitngCustomerButton.classList.add(...cls);
      newCustomerButton.classList.add(...cls);
      // if (isOutageBannerEnabled && JSON.parse(isOutageBannerEnabled.value)) {
      //   const error = [{ messages: "isOutageBannerEnabled" }];
      //   handleError(error, metaData);
      // }
    }
    if (businessCustomerButton) {
      businessCustomerButton.onclick = function () {
        window.open(businessCustomerURL, "_blank");
      };
    }
  }
  if (metaData.stepName === "Cancel Services") {
    const cancelButton: any = document.querySelectorAll("#cancelOverXfinity")[0];
    const cancelOverPhoneButton: any = document.querySelectorAll("#cancelOverPhone")[0];
    const BereavementButton: any = document.querySelectorAll("#Bereavement")[0];
    if (cancelButton) {
      cancelButton.onclick = function () {
        window.open(cancelServiceURL, "_blank");
      };
    }
    if (cancelOverPhoneButton) {
      cancelOverPhoneButton.onclick = function () {
        window.open(cancelOverPhoneURL, "_blank");
      };
    }
    if (BereavementButton) {
      BereavementButton.onclick = function () {
        window.open(bereavementURL, "_blank");
      };
    }
  }
  const getExistingCustomerReasonPageStatus = () => {
    const followUpQuestionId1: any = document.querySelectorAll("[rsmonitor='followUpQuestionId1']")[0];
    const followUpQuestionId2: any = document.querySelectorAll("[rsmonitor='followUpQuestionId2']")[0];
    const answerIdSelected: any = document.querySelectorAll("[data-rsmonitor='answerIdSelected']")[0];
    const submitButton: any = document.querySelectorAll("[rsmonitor='submitButton']");
    const selectedServices: any = document.getElementById("selectedServicesList");
    for (let i = 0; i < submitButton.length; i++) {
      if (submitButton[i].value === "dateAndTime") {
        const list = submitButton[i].classList;
        if (answerIdSelected && !answerIdSelected.value) {
          list.add("disabledButton");
          list.remove("enableButton");
        }
        if (
          followUpQuestionId1 &&
          !followUpQuestionId1.value &&
          followUpQuestionId2 &&
          !followUpQuestionId2.value &&
          answerIdSelected &&
          answerIdSelected.value
        ) {
          list.remove("disabledButton");
          list.add("enableButton");
        }

        if (
          followUpQuestionId1 &&
          followUpQuestionId1.value &&
          followUpQuestionId2 &&
          !followUpQuestionId2.value &&
          ((selectedServices && selectedServices.textContent && selectedServices.textContent.trim().length === 0) ||
            !selectedServices)
        ) {
          list.remove("enableButton");
          list.add("disabledButton");
        }
        if (
          followUpQuestionId1 &&
          followUpQuestionId1.value &&
          followUpQuestionId2 &&
          !followUpQuestionId2.value &&
          selectedServices &&
          selectedServices.textContent &&
          selectedServices.textContent.trim().length > 0
        ) {
          list.remove("disabledButton");
          list.add("enableButton");
        }
      }
    }
  };
  if (metaData.pageName === "Reason Details Existing") {
    setTimeout(() => {
      getExistingCustomerReasonPageStatus();
    });
    const servicesList: any = document.getElementById("showServiceList");
    if (servicesList && sessionStorage.getItem("userSelected") === "customer") {
      servicesList.addEventListener("change", () => {
        getExistingCustomerReasonPageStatus();
      });
    }
  }
};
